import type { TFunction } from 'i18next';

/** Milliseconds for sorting; a project without a time sorts last. */
export function lastActivityTime(at: string | null | undefined): number {
  const time = at ? new Date(at).getTime() : NaN;
  return Number.isNaN(time) ? 0 : time;
}

/**
 * "Senast uppdaterad" as the lists show it: today and yesterday with the
 * time ("Idag 09:14", "Igår 16:42"), older changes with the date, in the
 * same format as the lists' other dates.
 */
export function formatLastActivity(at: string | null | undefined, t: TFunction, now: Date = new Date()): string {
  const time = lastActivityTime(at);
  if (!time) return '—';
  const date = new Date(time);
  const startOfDay = (value: Date) => new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime();
  const days = Math.round((startOfDay(now) - startOfDay(date)) / 86_400_000);
  const clock = date.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' });
  if (days === 0) return t('projects.lastActivity.today', { time: clock });
  if (days === 1) return t('projects.lastActivity.yesterday', { time: clock });
  return date.toLocaleDateString('sv-SE');
}
